import KpiStrip from "../KpiStrip/KpiStrip"
import { PanelHead } from "../Panel/Panel"

import styles from "./kpiBeside.module.less"

// A card's KPIs with one panel beside them (DAA-1-22): Match rate's By channel, Time to Active's
// Trend. The KPIs take the left half, the panel the right one, split by a hairline; below 1100 px the
// panel moves under the KPIs (DAA-1-27).
const KpiBeside = ({ tiles, title, tag, children }) => (
  <div className={styles.beside}>
    <KpiStrip tiles={tiles} />
    <section className={styles.panel}>
      <PanelHead title={title} tag={tag} />
      {children}
    </section>
  </div>
)

export default KpiBeside
